/** Tampon glissant : seules les images des `windowMs` dernières millisecondes sont gardées. */
export interface TimedFrame<T> {
  readonly t: number;
  readonly data: T;
}

export interface ClipBuffer<T> {
  push(t: number, data: T): void;
  /** Copie des images (les `lastMs` dernières si précisé). */
  snapshot(lastMs?: number): TimedFrame<T>[];
  clear(): void;
}

export function createClipBuffer<T>(windowMs: number): ClipBuffer<T> {
  let frames: TimedFrame<T>[] = [];
  return {
    push(t, data) {
      const last = frames.at(-1);
      if (last && t <= last.t) return;
      frames.push({ t, data });
      const from = t - windowMs;
      while (frames.length > 0 && (frames[0]?.t ?? 0) < from) frames.shift();
    },
    snapshot(lastMs = windowMs) {
      const end = frames.at(-1)?.t ?? 0;
      return frames.filter((f) => f.t >= end - lastMs);
    },
    clear() {
      frames = [];
    },
  };
}
